import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PackageConfigurationServices } from './packageConfiguration.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-package-configuration',
  templateUrl: './package-configuration.component.html',
  styleUrls: ['./package-configuration.component.sass']
})
export class PackageConfigurationComponent implements OnInit {
  helpersBasicAmount:any;
  couponBasicAmount:any;
  tripFareGST:any;
  helperGST:any;
  commissionFee:any;
  commissionFeeGST:any;
  convenienceFee:any;
  convenienceFeeGST:any;
  minimumDistanceForTrip:any;
  helperTDS:any;
  distanceForNotification:any;
 

  constructor(
    private spinner:NgxSpinnerService,
    private packageConfigurationService:PackageConfigurationServices,
    private toastr:ToastrService
  ) { }

  ngOnInit(): void {
  }

  packageConfiguration(){
    this.spinner.show()
    let data={
      "helpersBasicAmount":this.helpersBasicAmount,
      "couponBasicAmount":this.couponBasicAmount,
      "tripFareGST":this.tripFareGST,
      "helperGST":this.helperGST,
      "commissionFee":this.commissionFee,
      "commissionFeeGST":this.commissionFeeGST,
      "convenienceFee":this.convenienceFee,
      "convenienceFeeGST":this.convenienceFeeGST,
      "distanceForNotification":this.distanceForNotification,
      "minimumDistanceForTrip":this.minimumDistanceForTrip,
      "helperTDS":this.helperTDS
    }
    console.log("reqData", data)
 
    this.packageConfigurationService.packageConfig(data).subscribe((result:any)=>{
      if(result.statusCode==200){
        console.log( "packageConfigAdd",result)
        this.spinner.hide();
        this.toastr.success(result.message)
        this.helpersBasicAmount=0;
        this.commissionFee=0;
        this.commissionFeeGST=0;
        this.convenienceFee=0;
        this.convenienceFeeGST=0;
        this.helperGST=0;
        this.helperTDS=0;
        this.couponBasicAmount=0;
        this.tripFareGST;
        this.distanceForNotification;
        this.minimumDistanceForTrip;
      }else{
        this.spinner.hide()
        this.toastr.error(result.message)
      }
    })
  }


}
